import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { invoiceConfigByCode } from 'entities';

import { IconButton, Table, Column, Row, Card } from 'components/Blocks';
import { EntityStatusTag } from 'components/Entities';

import { ReceiptLongIcon } from 'components/Icons';

import { InvoiceModal } from 'pages/Invoice/components';
import { CreatePackageInvoice } from './CreateInvoice';

import { formatCurrency } from 'utils/text';
import { getTimestampDisplay } from 'utils/date';

import { usePackage } from '../context';

export function PackageInvoices(): JSX.Element {
  const { t } = useLang();
  const { data, overwrite } = usePackage();

  const [invoice, setInvoice] = useState<string | null>(null);

  return (
    <Column>
      <Row justifyContent="space-between">
        <h6 className="text-2xl font-medium text-primary phone:text-xl">{t('invoices')}</h6>

        <CreatePackageInvoice />
      </Row>

      {data.invoices.length ? (
        <>
          <InvoiceModal
            invoice={invoice}
            close={() => setInvoice(null)}
            onData={(inv) =>
              overwrite((old) => ({
                ...old,
                invoices: old.invoices.map((invoice) =>
                  invoice.invoice !== inv.id
                    ? invoice
                    : {
                        ...invoice,
                        status: inv.status,
                      },
                ),
              }))
            }
          />

          <Card>
            <Table
              items={data.invoices}
              uniqueKey="invoice"
              spacing="medium"
              columns={[
                {
                  label: t('total') as string,
                  render: ({ invoiceValue, currency }) => formatCurrency(invoiceValue, currency),
                  filter: true,
                  getTextValue: ({ currency }) => currency,
                },
                {
                  label: t('value') as string,
                  render: ({ value, currency }) => formatCurrency(value, currency),
                  filter: true,
                  getTextValue: ({ currency }) => currency,
                },
                {
                  label: t('created-at') as string,
                  render: ({ createdAt }) => getTimestampDisplay(createdAt),
                },
                {
                  label: t('status') as string,

                  filter: true,
                  getTextValue: ({ status }) => invoiceConfigByCode[status].getLabel(t),

                  render: ({ status }) => (
                    <EntityStatusTag target="invoice" status={status} round={false} size="medium" />
                  ),
                },
                {
                  render: ({ invoice }) => (
                    <IconButton
                      className="ml-auto flex"
                      tooltipContent={t('view-invoice')}
                      onClick={() => setInvoice(invoice)}
                    >
                      <ReceiptLongIcon />
                    </IconButton>
                  ),
                },
              ]}
            />
          </Card>
        </>
      ) : (
        <Card>
          <p className="text-center text-lg font-medium">{t('no-invoice-found')}</p>
        </Card>
      )}
    </Column>
  );
}
